import React from 'react'

const AgentPodcast = ({ embed }) => (
  <section className='agent-podcast'>
    <div className='agent-podcast__inner'>
      <div dangerouslySetInnerHTML={{ __html: embed }} />
    </div>
  </section>
)

AgentPodcast.defaultProps = {
  embed: null
}

export default AgentPodcast